import type { CaloriesRange } from "../types/calories-calculator.type";

export const findCaloriesRangeLabel = (
  countedValue: number,
  ranges: CaloriesRange[],
): string | null => {
  const firstRange = ranges.at(0);
  const lastRange = ranges.at(-1);

  if (!(firstRange && lastRange)) {
    return null;
  }

  if (countedValue < 0) {
    return firstRange.label;
  }

  if (countedValue > lastRange.to) {
    return lastRange.label;
  }

  const matchedRange = ranges.find(
    (range) => countedValue >= range.from && countedValue <= range.to,
  );

  return matchedRange?.label ?? null;
};
